/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import { interpolate } from "flubber";
import React from "react";
import { Animated, Easing, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, GProps, Path as SVG_Path, PathProps } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
// const ForeignObject = Animated.createAnimatedComponent(SVG_ForeignObject);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"> <desc id="IMP.BLUE">{"#AnimatedPlusSignButtonGray":{"type":"SELECTOR","constraint":"none","width":66,"height":112},"#Property_201_3DDefault":{"type":"SELECTOR","constraint":"xMinYMin meet","width":26,"height":26},"#square":{"type":"SELECTOR","constraint":"none","width":22,"height":22},"#Back":{"type":"SELECTOR","constraint":"none","width":18.857168197631836,"height":18.857168197631836},"#Plus":{"type":"SELECTOR","constraint":"none","width":10,"height":10},"#Property_201_3DVariant2":{"type":"SELECTOR","constraint":"xMinYMin meet","width":26,"height":26},"transforms":{},"morph":{"condition":"props.morph","targets":{"Property_1=Default":{"type":"ease","duration":150,"delay":0},"Property_1=Variant2":{"type":"ease","duration":150,"delay":0}},"numStates":2},"#size_3Dsmall":{"type":"SELECTOR","constraint":"xMinYMin meet","width":26,"height":26},"#Property_201_3DBig":{"type":"SELECTOR","constraint":"xMinYMin meet","width":26,"height":26},"#size_3Dbig":{"type":"SELECTOR","constraint":"xMinYMin meet","width":26,"height":26},"#AnimatedPlusSign":{"type":"SELECTOR","constraint":"none","width":66,"height":112}}</desc>
 * <g id="size=small">
 * <path id="square" d="M19.4285 3H6.57141C4.59994 3.00234 3.00234 4.59994 3 6.57141V19.4285C3.00234 21.4 4.59994 22.9976 6.57141 23H19.4285C21.4 22.9976 22.9976 21.4 23 19.4285V6.57141C22.9976 4.59994 21.4 3.00234 19.4285 3ZM21.5714 19.4285C21.5714 20.612 20.612 21.5714 19.4285 21.5714H6.57141C5.38794 21.5714 4.42856 20.612 4.42856 19.4285V6.57141C4.42856 5.38794 5.38794 4.42856 6.57141 4.42856H19.4285C20.612 4.42856 21.5714 5.38794 21.5714 6.57141V19.4285Z" fill={fill}/>
 * <path id="Back" d="M21.5725 19.4285C21.5725 20.612 20.6131 21.5714 19.4297 21.5714H6.57254C5.38908 21.5714 4.42969 20.612 4.42969 19.4285V6.57141C4.42969 5.38794 5.38908 4.42856 6.57254 4.42856H19.4297C20.6131 4.42856 21.5725 5.38794 21.5725 6.57141V19.4285Z" fill="white"/>
 * <path id="Plus" d="M16.572 12.2857H13.7149V9.42853C13.7149 9.03403 13.3951 8.71423 13.0006 8.71423C12.6061 8.71423 12.2863 9.03403 12.2863 9.42853V12.2857H9.42914C9.03464 12.2857 8.71484 12.6055 8.71484 13C8.71484 13.3945 9.03464 13.7142 9.42914 13.7142H12.2863V16.5714C12.2863 16.9659 12.6061 17.2857 13.0006 17.2857C13.3951 17.2857 13.7149 16.9658 13.7149 16.5714V13.7142H16.572C16.9665 13.7142 17.2863 13.3944 17.2863 12.9999C17.2863 12.6054 16.9665 12.2857 16.572 12.2857Z" fill={fill}/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
 * <g id="size=big">
 * <path id="square" d="M20.0714 2H5.92856C3.75994 2.00258 2.00258 3.75994 2 5.92856V20.0714C2.00258 22.2401 3.75994 23.9974 5.92856 24H20.0714C22.2401 23.9974 23.9974 22.2401 24 20.0714V5.92856C23.9974 3.75994 22.2401 2.00258 20.0714 2ZM22.4286 20.0714C22.4286 21.3733 21.3733 22.4286 20.0714 22.4286H5.92856C4.62674 22.4286 3.57142 21.3733 3.57142 20.0714V5.92856C3.57142 4.62674 4.62674 3.57142 5.92856 3.57142H20.0714C21.3733 3.57142 22.4286 4.62674 22.4286 5.92856V20.0714Z" fill={fill}/>
 * <path id="Back" d="M22.4275 20.0714C22.4275 21.3733 21.3722 22.4286 20.0703 22.4286H5.92746C4.62564 22.4286 3.57031 21.3733 3.57031 20.0714V5.92857C3.57031 4.62675 4.62564 3.57142 5.92746 3.57142H20.0703C21.3722 3.57142 22.4275 4.62675 22.4275 5.92857V20.0714Z" fill="white"/>
 * <path id="Plus" d="M17.1667 12.1667H13.8333V8.83335C13.8333 8.37309 13.4602 8 13 8C12.5397 8 12.1666 8.37309 12.1666 8.83335V12.1667H8.83335C8.37309 12.1667 8 12.5398 8 13C8 13.4603 8.37309 13.8333 8.83335 13.8333H12.1667V17.1667C12.1667 17.6269 12.5398 18 13 18C13.4603 18 13.8333 17.6269 13.8333 17.1667V13.8333H17.1667C17.6269 13.8333 18 13.4602 18 13C18 12.5397 17.6269 12.1667 17.1667 12.1667Z" fill={fill}/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#AnimatedPlusSignButtonGray": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 66,
 * 		"height": 112
 * 	},
 * 	"#Property_201_3DDefault": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 26,
 * 		"height": 26
 * 	},
 * 	"#square": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 22,
 * 		"height": 22
 * 	},
 * 	"#Back": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 18.857168197631836,
 * 		"height": 18.857168197631836
 * 	},
 * 	"#Plus": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 10,
 * 		"height": 10
 * 	},
 * 	"#Property_201_3DVariant2": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 26,
 * 		"height": 26
 * 	},
 * 	"transforms": {},
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"Property_1=Default": {
 * 				"type": "ease",
 * 				"duration": 150,
 * 				"delay": 0
 * 			},
 * 			"Property_1=Variant2": {
 * 				"type": "ease",
 * 				"duration": 150,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	},
 * 	"#size_3Dsmall": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 26,
 * 		"height": 26
 * 	},
 * 	"#Property_201_3DBig": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 26,
 * 		"height": 26
 * 	},
 * 	"#size_3Dbig": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 26,
 * 		"height": 26
 * 	},
 * 	"#AnimatedPlusSign": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 66,
 * 		"height": 112
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  size?: "small" | "big";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d, matrix }: { d?: string; matrix?: number[] }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigsquared: string | number | Animated.AnimatedInterpolation;
  morphConfigBackd: string | number | Animated.AnimatedInterpolation;
  morphConfigPlusd: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const AnimatedPlusSign = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  size?: "small" | "big";
  fill?: string;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 26,
      height: 26,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    fill = "#4f4f4f",
    svgRef,
  } = props;
  // const kRenderInstanceID = Math.random().toString().replace(".", "");
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigsquared:
        "M19.4285 3H6.57141C4.59994 3.00234 3.00234 4.59994 3 6.57141V19.4285C3.00234 21.4 4.59994 22.9976 6.57141 23H19.4285C21.4 22.9976 22.9976 21.4 23 19.4285V6.57141C22.9976 4.59994 21.4 3.00234 19.4285 3ZM21.5714 19.4285C21.5714 20.612 20.612 21.5714 19.4285 21.5714H6.57141C5.38794 21.5714 4.42856 20.612 4.42856 19.4285V6.57141C4.42856 5.38794 5.38794 4.42856 6.57141 4.42856H19.4285C20.612 4.42856 21.5714 5.38794 21.5714 6.57141V19.4285Z",
      morphConfigBackd:
        "M21.5725 19.4285C21.5725 20.612 20.6131 21.5714 19.4297 21.5714H6.57254C5.38908 21.5714 4.42969 20.612 4.42969 19.4285V6.57141C4.42969 5.38794 5.38908 4.42856 6.57254 4.42856H19.4297C20.6131 4.42856 21.5725 5.38794 21.5725 6.57141V19.4285Z",
      morphConfigPlusd:
        "M16.572 12.2857H13.7149V9.42853C13.7149 9.03403 13.3951 8.71423 13.0006 8.71423C12.6061 8.71423 12.2863 9.03403 12.2863 9.42853V12.2857H9.42914C9.03464 12.2857 8.71484 12.6055 8.71484 13C8.71484 13.3945 9.03464 13.7142 9.42914 13.7142H12.2863V16.5714C12.2863 16.9659 12.6061 17.2857 13.0006 17.2857C13.3951 17.2857 13.7149 16.9658 13.7149 16.5714V13.7142H16.572C16.9665 13.7142 17.2863 13.3944 17.2863 12.9999C17.2863 12.6054 16.9665 12.2857 16.572 12.2857Z",
    },
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  // const useOnLayout = (onLayout: (event: LayoutChangeEvent) => void) => {
  //   type tWebElement = {
  //     getBoundingClientRect: () => {
  //       x: number;
  //       y: number;
  //       width: number;
  //       height: number;
  //     };
  //     getScreenCTM: () => {
  //       f: number;
  //     };
  //   };
  //   const ref = React.useRef(null);
  //   const myCallback = React.useCallback(onLayout, [onLayout]);

  //   const getElementDimensions = () => {
  //     if (!ref || !ref?.current || Platform.OS !== "web") {
  //       return;
  //     }

  //     const { isInsideScrollView } = props;
  //     const thisElement =
  //       (
  //         ref?.current as unknown as {
  //           _touchableNode: tWebElement;
  //         }
  //       )?._touchableNode ?? (ref?.current as unknown as tWebElement);
  //     const yOffset = thisElement?.getScreenCTM()?.f ?? 0;
  //     const bBox = thisElement?.getBoundingClientRect() ?? {
  //       x: 0,
  //       y: 0,
  //       width: 0,
  //       height: 0,
  //     };
  //     const { x = 0, y: aY = 0, width = 0, height = 0 } = bBox;
  //     let y = aY;

  //     if (isInsideScrollView) {
  //       y = aY - yOffset;
  //     }

  //     const layoutEvent = {
  //       nativeEvent: {
  //         layout: {
  //           x,
  //           y,
  //           width,
  //           height,
  //         },
  //       },
  //     };
  //     myCallback(layoutEvent as LayoutChangeEvent);
  //   };

  //   const myGetElementDimensions = React.useCallback(getElementDimensions, [myCallback]);
  //   React.useEffect(() => {
  //     if (!ref || !ref?.current || Platform.OS !== "web") {
  //       return undefined;
  //     } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //     // @ts-ignore ('window' will be defined in the web environment!)

  //     window.addEventListener("resize", myGetElementDimensions, false); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //     // @ts-ignore ('window' will be defined in the web environment!)

  //     window.dispatchEvent(new Event("resize")); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //     // @ts-ignore ('window' will be defined in the web environment!)

  //     return () => window.removeEventListener("resize", myGetElementDimensions, false);
  //   }, [myGetElementDimensions]);
  //   return ref;
  // };
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    size: "small" | "big";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      size: "small",
    },
    1: {
      size: "big",
    },
  };

  function getNextMorphState(): number {
    const { size, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].size === size) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;
  const maxSegmentLength = props?.maxSegmentLength ?? 1;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) => {
    let result = 0;
    const aNumerator = x - Math.min(bound1, bound2);
    const aDenominator = Math.max(bound1, bound2) - Math.min(bound1, bound2);

    if (aDenominator !== 0) {
      result = aNumerator / aDenominator;
    }

    if (Number.isNaN(result)) {
      result = 0;
    }

    return result;
  };
  /**
   * Generates an interpolation function from 2 Matrices
   * This function will perform component-wise linear interpolation from matrix A to B at a given time value t
   */

  const interpolateMatrices = (m1: number[], m2: number[]) => {
    // linear interpolation
    const lerp = (x0: number, x1: number, t: number) => x0 * (1 - t) + x1 * t;

    return (t: number) => m1.map((x0, i) => lerp(x0, m2[i], t));
  };

  type tMorphInterpolation = {
    type: "Morph";
    morphId: keyof tMorphProps;
    paths: string[];
  };
  type tMatrixInterpolation = {
    type: "Matrix";
    morphId: keyof tMorphProps;
    matrices: number[][];
  };
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<tMorphInterpolation | tMatrixInterpolation>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      if (interpolations.length === 0) return () => 0;
      type tInterpolator = (t: number) => string;
      type tInterpolatorMorph = {
        type: "Normal" | "SubPath";
        interpolator: (t: number) => string;
      };
      type tInterpolatorMatrix = {
        type: "Matrix";
        interpolator: (t: number) => number[];
      };

      const toSubPaths = (myPath: string) =>
        String(myPath)
          .split(/m|M/)
          .filter((subPath) => Boolean(subPath))
          .map((subPath) => `M${subPath}${subPath.endsWith("Z") ? "" : "Z"}`);

      const interpolators: {
        [morphId: string]: tInterpolatorMorph | tInterpolatorMatrix;
      } = {};
      interpolations.forEach((interpolation) => {
        if (interpolation.type === "Morph") {
          const { morphId, paths } = interpolation;
          const initial = paths[start];
          const final = paths[end];
          const p1 = start > end ? final : initial;
          const p2 = start > end ? initial : final;
          const defaultInterpolator = interpolate(p1, p2, {
            maxSegmentLength,
          });
          const p1SubPaths = toSubPaths(p1);
          const p2SubPaths = toSubPaths(p2);
          const newSubPaths: tInterpolator[] = [];
          let type: tInterpolatorMorph["type"] = "Normal";

          if (p1SubPaths.length > 1 && p2SubPaths.length > 1 && p1SubPaths.length === p2SubPaths.length) {
            type = "SubPath";

            for (let i = 0; i < p1SubPaths.length; i += 1) {
              const subP1 = p1SubPaths[i];
              const subP2 = p2SubPaths[i];
              newSubPaths.push(
                interpolate(subP1, subP2, {
                  maxSegmentLength,
                }),
              );
            }
          }

          const interpolator = (t: number) => {
            if (type === "SubPath") {
              return `${newSubPaths.map((subInterpolator) => subInterpolator(t).replace(/z|Z/g, "")).join(" ")}Z`;
            }

            return defaultInterpolator(t);
          };

          interpolators[morphId] = {
            type,
            interpolator,
          };
        } else if (interpolation.type === "Matrix") {
          const { type, morphId, matrices } = interpolation;
          const initial = matrices[start];
          const final = matrices[end];
          const m1 = start > end ? final : initial;
          const m2 = start > end ? initial : final;
          const interpolator = interpolateMatrices(m1, m2);
          interpolators[morphId] = {
            type,
            interpolator,
          };
        }
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.entries(interpolators).forEach(([morphId, interpolation]) => {
          const normal = normalize(value, start, end);
          let nextInterpolatedPath = "";
          let nextInterpolatedMatrix: number[] = [];

          if (interpolation.type === "Normal" || interpolation.type === "SubPath") {
            const { interpolator } = interpolation;
            nextInterpolatedPath = interpolator(normal);
          }

          if (interpolation.type === "Matrix") {
            const { interpolator } = interpolation;
            nextInterpolatedMatrix = interpolator(normal);
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              if (interpolation.type !== "Matrix") {
                thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
              } else {
                thisRef?._touchableNode?.setAttribute("transform", `matrix(${nextInterpolatedMatrix.join(" ")})`);
              }
            } else if (interpolation.type !== "Matrix") {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            } else {
              thisRef?.setNativeProps({
                matrix: nextInterpolatedMatrix,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId);
    }, [interpolations, start, end]);
    return ((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown as tMorphRef;
  };

  const myInterpolations: Array<tMorphInterpolation | tMatrixInterpolation> = React.useMemo(
    () => [
      {
        type: "Matrix",
        morphId: "morphConfigsquared",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [
            1.1000031889019988, 6.800229102632149e-18, 6.688888953831906e-7, 1.1000025200131043, -1.300013962249167,
            -1.3000075600393122,
          ],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigBackd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [
            1.0999972000037341, 6.661338147750939e-16, -0.0000587987456223682, 1.100004666573332, -1.3010472256512386,
            -1.30004066452004,
          ],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigPlusd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [
            1.1667075006125107, 7.906800213470379e-16, -8.881784197001252e-16, 1.1666614167165403, -2.1679767001505112,
            -2.1665521673544106,
          ],
        ],
      },
    ],
    [],
  );
  morphProps.bindInterpolation = useGenerateMorphInterpolation(myInterpolations, startValue, endValue);
  // const morphValues: {
  //   [id: string]: string[] | number[];
  // } = {};

  // function clamp(lower: number, upper: number, v: number) {
  //   let r = v;

  //   if (r > upper) {
  //     r = upper;
  //   } else if (r < lower) {
  //     r = lower;
  //   }

  //   return r;
  // }

  // type tInterpolationRange = {
  //   inputRange: number[];
  //   outputRange: string[] | number[];
  // };

  // function getInterpolationRange(morphId: string, start: number, end: number): tInterpolationRange {
  //   const initial = clamp(0, 2, start);
  //   const final = clamp(0, 2, end);
  //   const inputRange = [start, end];
  //   const outputRange: string[] | number[] = [morphValues[morphId][initial], morphValues[morphId][final]] as
  //     | string[]
  //     | number[];

  //   if (start > end) {
  //     inputRange.reverse();
  //     outputRange.reverse();
  //   }

  //   return {
  //     inputRange,
  //     outputRange,
  //   };
  // }

  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 150,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 150,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 26 26"
        >
          <G id="size_3Dsmall">
            <Svg preserveAspectRatio="none" viewBox="0 0 26 26">
              <Path
                id="square"
                d="M19.4285 3H6.57141C4.59994 3.00234 3.00234 4.59994 3 6.57141V19.4285C3.00234 21.4 4.59994 22.9976 6.57141 23H19.4285C21.4 22.9976 22.9976 21.4 23 19.4285V6.57141C22.9976 4.59994 21.4 3.00234 19.4285 3ZM21.5714 19.4285C21.5714 20.612 20.612 21.5714 19.4285 21.5714H6.57141C5.38794 21.5714 4.42856 20.612 4.42856 19.4285V6.57141C4.42856 5.38794 5.38794 4.42856 6.57141 4.42856H19.4285C20.612 4.42856 21.5714 5.38794 21.5714 6.57141V19.4285Z"
                fill={fill}
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="none" viewBox="0 0 26 26">
              <Path
                id="Back"
                d="M21.5725 19.4285C21.5725 20.612 20.6131 21.5714 19.4297 21.5714H6.57254C5.38908 21.5714 4.42969 20.612 4.42969 19.4285V6.57141C4.42969 5.38794 5.38908 4.42856 6.57254 4.42856H19.4297C20.6131 4.42856 21.5725 5.38794 21.5725 6.57141V19.4285Z"
                fill="white"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="none" viewBox="0 0 26 26">
              <Path
                id="Plus"
                d="M16.572 12.2857H13.7149V9.42853C13.7149 9.03403 13.3951 8.71423 13.0006 8.71423C12.6061 8.71423 12.2863 9.03403 12.2863 9.42853V12.2857H9.42914C9.03464 12.2857 8.71484 12.6055 8.71484 13C8.71484 13.3945 9.03464 13.7142 9.42914 13.7142H12.2863V16.5714C12.2863 16.9659 12.6061 17.2857 13.0006 17.2857C13.3951 17.2857 13.7149 16.9658 13.7149 16.5714V13.7142H16.572C16.9665 13.7142 17.2863 13.3944 17.2863 12.9999C17.2863 12.6054 16.9665 12.2857 16.572 12.2857Z"
                fill={fill}
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 26 26"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="square"
          d="M19.4285 3H6.57141C4.59994 3.00234 3.00234 4.59994 3 6.57141V19.4285C3.00234 21.4 4.59994 22.9976 6.57141 23H19.4285C21.4 22.9976 22.9976 21.4 23 19.4285V6.57141C22.9976 4.59994 21.4 3.00234 19.4285 3ZM21.5714 19.4285C21.5714 20.612 20.612 21.5714 19.4285 21.5714H6.57141C5.38794 21.5714 4.42856 20.612 4.42856 19.4285V6.57141C4.42856 5.38794 5.38794 4.42856 6.57141 4.42856H19.4285C20.612 4.42856 21.5714 5.38794 21.5714 6.57141V19.4285Z"
          fill={fill}
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 26 26"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Back"
          d="M21.5725 19.4285C21.5725 20.612 20.6131 21.5714 19.4297 21.5714H6.57254C5.38908 21.5714 4.42969 20.612 4.42969 19.4285V6.57141C4.42969 5.38794 5.38908 4.42856 6.57254 4.42856H19.4297C20.6131 4.42856 21.5725 5.38794 21.5725 6.57141V19.4285Z"
          fill="white"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 26 26"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Plus"
          d="M16.572 12.2857H13.7149V9.42853C13.7149 9.03403 13.3951 8.71423 13.0006 8.71423C12.6061 8.71423 12.2863 9.03403 12.2863 9.42853V12.2857H9.42914C9.03464 12.2857 8.71484 12.6055 8.71484 13C8.71484 13.3945 9.03464 13.7142 9.42914 13.7142H12.2863V16.5714C12.2863 16.9659 12.6061 17.2857 13.0006 17.2857C13.3951 17.2857 13.7149 16.9658 13.7149 16.5714V13.7142H16.572C16.9665 13.7142 17.2863 13.3944 17.2863 12.9999C17.2863 12.6054 16.9665 12.2857 16.572 12.2857Z"
          fill={fill}
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(AnimatedPlusSign);
